import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
// import { None } from "../../Entity/Entities/Person/Role/Roles/None";
import Http from "../../Http/Http";
import Translator from "../../Translation/Translator";
import PersonFactory from "../../Entity/Factories/PersonFactory";
import SubscriptionFactory from "../../Entity/Factories/SubscriptionFactory";
import { SubscriptionInterface } from "../../Entity/Entities/Subscription/SubscriptionInterface";
import { ActionInterface } from "../../Interface/ActionInterface";
import { PersonInterface } from "../../Entity/Entities/Person/PersonInterface";
import { EmailAccountInterface } from "../../Entity/Entities/EmailAccount/EmailAccountInterface";
import EmailAccountFactory from "../../Entity/Factories/EmailAccountFactory";

export function* personCreate(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.PAGE_CONTACT_PERSON_CREATE_CLEAR
    });
    
    yield put({
      type: Constants.PAGE_CONTACT_PERSON_CREATE_REQUEST
    });

    const companiesForPerson: any[] = [];

    if (action.payload?.person?.company?.id || action.payload?.person?.companyId) {
      companiesForPerson.push({
        id: action.payload?.person?.company?.id || action.payload?.person?.companyId,
        role: action.payload?.person?.companyRole || ""
      });
    }
    
    // If we have additional fields, we have to push those into the array too.
    action.payload?.person?.additionalFields?.forEach(field => {
      if (!field) {
        return;
      }

      if (!field?.selectedCompany) {
        return;
      }

      companiesForPerson.push({
        id: field?.selectedCompany?.id,
        role: field?.role || ""
      });
    });
    
    const res = yield call(Http.post, "contact", {...action.payload?.person, companyIds: [...companiesForPerson]});
    const person: PersonInterface = PersonFactory.create(res.data.contact);
    const subscription: SubscriptionInterface = SubscriptionFactory.create(res.data.subscription);

    yield put({
      type: Constants.PAGE_CONTACT_PERSON_CREATE_SUCCESS,
      payload: {
        person: person
      }
    });

    yield put({
      type: Constants.GLOBAL_SUBSCRIPTION_CREATE_SUCCESS,
      payload: {
        subscription: subscription
      }
    });

    // If we created an user or an admin, we also created his email account so we have to check it.
    if (res.data.additionalData.hasOwnProperty("emailAccount") === true) {
      // @todo make sure to keep the same thing here and in EmailAccountCreate.ts saga.
      const emailAccount: EmailAccountInterface = EmailAccountFactory.create(res.data.additionalData.emailAccount);
      const emailSubscription: SubscriptionInterface = SubscriptionFactory.create(res.data.additionalData.subscription);

      yield put({
        type: Constants.PAGE_SETTINGS_EMAIL_ACCOUNT_CREATE_SUCCESS,
        payload: {
          emailAccount: emailAccount
        }
      });

      yield put({
        type: Constants.GLOBAL_SUBSCRIPTION_CREATE_SUCCESS,
        payload: {
          subscription: emailSubscription
        }
      });
    }

    // show snackbar
    if (person?.isUser() || person?.isAdmin()) {
      yield put({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: Translator.trans("snackbar-message-user-created-successfully"),
          type: "success"
        }
      });
    } else {
      yield put({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: Translator.trans(`snackbar-message-${action.payload?.person.pageTemplate}-created-successfully`),
          type: "success"
        }
      });
    }

    yield put({
      type: Constants.PAGE_CONTACTS_SWITCH_TAB,
      payload: {
        index: 0
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, person);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.PAGE_CONTACT_PERSON_CREATE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* lookupPersonCreate(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.LOOKUP_COMPONENT_PERSON_CREATE_REQUEST
    });
    const res = yield call(Http.post, "contact", action.payload?.person);
    const person: PersonInterface = PersonFactory.create(res.data.contact);
    const subscription: SubscriptionInterface = SubscriptionFactory.create(res.data.subscription);

    yield put({
      type: Constants.LOOKUP_COMPONENT_PERSON_CREATE_SUCCESS,
      payload: {
        person: person
      }
    });

    yield put({
      type: Constants.GLOBAL_SUBSCRIPTION_CREATE_SUCCESS,
      payload: {
        subscription: subscription
      }
    });

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans(`snackbar-message-${action.payload?.person.pageTemplate}-created-successfully`),
        type: "success"
      }
    });
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.LOOKUP_COMPONENT_PERSON_CREATE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* companyDialogPersonCreate(action: ActionInterface): any {
  try {
    const res = yield call(Http.post, "contact", {
      companyId: action.payload?.id,
      firstName: action.payload?.person.firstName,
      contactRoleId: null
    });

    const person: PersonInterface = PersonFactory.create(res.data.contact);
    const subscription: SubscriptionInterface = SubscriptionFactory.create(res.data.subscription);

    yield put({
      type: Constants.PAGE_CONTACT_PERSON_CREATE_SUCCESS,
      payload: {
        person: person
      }
    });

    yield put({
      type: Constants.GLOBAL_SUBSCRIPTION_CREATE_SUCCESS,
      payload: {
        subscription: subscription
      }
    });

    if (!action.payload?.hideSnackbar) { 
      yield put({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: Translator.trans(`snackbar-message-${action.payload?.person.pageTemplate}-created-successfully`),
          type: "success"
        }
      });
    }

    if (typeof action.onSuccess !== "undefined") {
      action.onSuccess.call(this, person);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchPersonCreate() {
  yield takeEvery(Constants.PAGE_CONTACT_PERSON_CREATE_START, personCreate);
  yield takeEvery(Constants.LOOKUP_COMPONENT_PERSON_CREATE_START, lookupPersonCreate);
  yield takeEvery(Constants.GLOBAL_COMPANY_ADD_PERSON_AFTER_CREATING, companyDialogPersonCreate);
}
